module.exports = __webpack_public_path__ + "img/temp_pub_1.af42ddc3.jpg";